import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/auth/AuthContext";
export default function SetPasswordRoute({ children }) {
    const { challengeData } = useAuth();
    // If no challenge data, redirect to login
    if (!challengeData) {
        return /*#__PURE__*/ _jsx(Navigate, {
            to: "/login",
            replace: true
        });
    }
    // Valid challenge session, render the page
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
